module.exports = __webpack_public_path__ + "img/medal3.3b552d02.svg";